import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box, LinearProgress } from '@mui/material';

import useNotification from '../../../../../../core/hooks/use_notification';
import { getAllFoodPartnersAction, getAllFoodPartnersState } from '../../../../../../features/food_partner/get_all_food_partners';
import { getAllFoodPartnersNotificationData } from '../../../../../../core/utils/notification_utils';
import GeneralDataForm from './general_data_form';
import FormWithoutLocationDivision from './form_without_location_division';
import FormWithLocationDivision from './form_with_location_division';
import Summary from './summary';
import { ROUTE_FOOD_PARTNER_ORDERS } from '../../../../../../core/constants';
import PageHeader from "../../../../../common/page_header";

const FoodPartnerOrderCreateForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showErrorMessage } = useNotification();

    const getFoodPartners = useSelector(getAllFoodPartnersState);

    const [view, setView] = useState(0);
    const [form, setForm] = useState({});
    const [data, setData] = useState({});
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        dispatch(getAllFoodPartnersAction())
            .then(response => showErrorMessage(getAllFoodPartnersNotificationData(response)));
    }, [dispatch, showErrorMessage]);

    const onSubmitGeneralData = (values) => {
        const locationDivision = values?.locationDivision;
        setForm(values);

        if (locationDivision) {
            setView(2);
        } else {
            setView(1);
        }
    };

    const renderView = () => {
        if (getFoodPartners?.loading) {
            return (
                <Box mt={ 6 } width="100%">
                    <LinearProgress/>
                </Box>
            );
        }

        if (getFoodPartners?.data) {
            if (view === 1) {
                return (
                    <FormWithoutLocationDivision
                        form={ form }
                        setView={ setView }
                        data={ data }
                        setData={ setData }/>
                );
            } else if (view === 2) {
                return (
                    <FormWithLocationDivision
                        form={ form }
                        setView={ setView }
                        data={ data }
                        setData={ setData }
                        errors={ errors }
                        setErrors={ setErrors }/>
                );
            } else if (view === 3) {
                return (
                    <Summary setView={ setView } data={ data } setErrors={ setErrors }/>
                );
            } else {
                return (
                    <GeneralDataForm
                        form={ form }
                        onSubmitGeneralData={ onSubmitGeneralData }/>
                );
            }
        }

        return null;
    };

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3 } }>
            <PageHeader
                title="Kreator zamówień do dostawców"
                showBack={ true }
                onBack={ () => navigate(ROUTE_FOOD_PARTNER_ORDERS) }
            />
            { renderView() }
        </Box>
    );
};

export default FoodPartnerOrderCreateForm;